import { DarkGlass } from 'components/DarkGlass'
import styled, { keyframes } from 'styled-components'
import { hexRgba } from 'utils/style-fns'
import { black } from 'utils/style-utils'

const slideIn = keyframes`
  0%   { bottom: -200px; }
  100% { bottom: 0; }
`

export const Box = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 10;
`

export const DialogBox = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  background: ${black};

  animation: ${slideIn} 0.2s ease-out;
`

export const ImageBox = styled.div`
  position: absolute;
  top: -2.5rem;
  left: 1.5rem;

  width: 8rem;
  flex: 1;
`

export const Title = styled.h3`
  margin: 1rem 1rem 1rem 11rem;

  font-size: 1.25rem;
`

const blurIn = keyframes`
  0%   { opacity: 0; }
  100% { opacity: 1; }
`

export const Glass = styled(DarkGlass)`
  background: linear-gradient(to bottom, ${hexRgba(black, 0)} 20%, ${hexRgba(black, 1)} 65%);
  backdrop-filter: unset;

  animation: ${blurIn} 0.2s linear;
`
